import {configureStore, createSlice} from '@reduxjs/toolkit';
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import { ProductsRelDocs} from "../interfaces";
import { getProductsRelDocs} from "./data-service";
import {IMenuSticky} from "../../../menus/menu-sticky/interfaces";
import {getMenuSelected, getMenuSticky} from "../../../menus/menu-sticky/data-services/data-service";
import {getHashByPrefix, getJSONFromHtml} from "../../../../domain/common";
import {ProcessResult} from "../../../../domain/process-result/interfaces";
import {abtest_SubscribePopupVariants} from "../../../list-page/interfaces/interfaces";

interface StateInterface {
    isDebug: boolean;
    isDebugTechSpecs: boolean;
    test: number;
    storetest: number;
    productsRelDocsInitial:ProductsRelDocs[],
    productsRelDocsInitialSelected:ProductsRelDocs,
    localTime: number,
    isUrlSelect: boolean,
    isProductOptionsSelected:boolean,
    isProductOptionsTouched:boolean,
    isSubsctiptionPlan:boolean,
    ImageCDNDomain:string,
    productPageUpgradeLink:number,
    productDataType:string,

    //techSpecs
    techSpecsSelectedTab:string,
    techSpecsRefreshHash:boolean,
    techSpecsSearchPlugins:string,

    // POPUP
    IsSubscriptionPlanPopupShown:boolean,
    PlanPricePopupShown: number,
    PlanPriceSavePopupShown: number,

    // ABTEST
    abtest_SubscribePopup: abtest_SubscribePopupVariants,

    //sticky
    hash: string;
    newHash: string;
    menuStickyList:IMenuSticky[],
    menuStickySelected:IMenuSticky
}

const prodList = getProductsRelDocs();
let  prodFindByParam = false;
let prodSelected = (prodList !== undefined && prodList!== null && prodList.length > 0) ?  prodList[0] : null;

/*-----------------------------------------------------------------DETECT if prodopt is subsctiption plan*/
let  _isSubsctiptionPlan = false;
if(prodSelected !== null)
    _isSubsctiptionPlan = ["15b353c4-391c-48ec-a163-335cbcc400c2"/*essential*/, "7253dcf6-ad30-4894-adbb-b6e3ce7b1269"/*ultimate*/].includes(prodSelected.nodeGUID);

/*-----------------------------------------------------------------DETECT prodopt in URL*/
const urlParams = new URLSearchParams(window.location.search);
if(urlParams.has('prodopt')) {
    const prodFind = prodList.find(f=>f.optionName.split(" ").join("-").toLowerCase() === urlParams.get('prodopt'))
    if(prodFind) {
        prodSelected = prodFind;
        prodFindByParam = true;
    }
}
else if(_isSubsctiptionPlan){
    const prodFind = prodList.find(f=>f.optionName.split(" ").join("-").toLowerCase() === 'annual')
    if(prodFind) {
        prodSelected = prodFind;
        prodFindByParam = true;
    }
}
else if(!_isSubsctiptionPlan){
    const prodFind = prodList.find(f=>f.skuEnabled && !f.isPreorder);
    if(prodFind) {
        prodSelected = prodFind;
        //prodFindByParam = true;
    }
}

const menuList = getMenuSticky();
const _hash =  getHashByPrefix('tab-')//window.location.hash.substring(1);

const _menuSelected = getMenuSelected(_hash, menuList);
const upgradelink = getJSONFromHtml(document.getElementById('upg-upgradelink')) as ProcessResult;
// initial state
const initialState: StateInterface = {
    isDebug: false,
    isDebugTechSpecs: false,
    test:1,
    storetest:9,
    productsRelDocsInitial: prodList,
    productsRelDocsInitialSelected: prodSelected || {} as ProductsRelDocs ,

    // counters
    localTime: (new Date()).getTime(),

    isUrlSelect: prodFindByParam,

    isProductOptionsSelected: prodFindByParam,
    isProductOptionsTouched: false,
    isSubsctiptionPlan: _isSubsctiptionPlan,
    ImageCDNDomain: (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase(),
    productPageUpgradeLink: upgradelink?.resultEX?.upgradePrice,

    productDataType:document.querySelector('meta[property="product-data-type"]')?.getAttribute('content') || '',

    //techSpecs
    techSpecsSelectedTab:"",
    techSpecsRefreshHash:false,
    techSpecsSearchPlugins:"",

    // POPUP
    IsSubscriptionPlanPopupShown:false,
    PlanPricePopupShown: 0,
    PlanPriceSavePopupShown: 0,
    // ABTEST
    abtest_SubscribePopup:abtest_SubscribePopupVariants.sbs_page,

    //sticky
    hash: _hash,
    newHash: '',
    menuStickyList: menuList,
    menuStickySelected: _menuSelected,
};

// the main slice
const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

const store = configureStore({
    reducer: rootSlice.reducer,
});

export const rootActions = rootSlice.actions;
export default store;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
